import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import {
  CarouselComponent,
  CarouselModule,
  OwlOptions,
} from 'ngx-owl-carousel-o';
import { BehaviorSubject } from 'rxjs';

import { NavigationMenuService } from '@shared/services/navigation-menu.service';

import helixLiteLogoSvg from '!!file-loader!./assets/logo-helix-lite.svg';
import step1 from '!!file-loader!./assets/credit-card.svg';
import step2 from '!!file-loader!./assets/mail.svg';
import step3 from '!!file-loader!./assets/marker-pin.svg';
import step4 from '!!file-loader!./assets/qr-code.svg';
import step5 from '!!file-loader!./assets/mail-result.svg';

interface HelixLiteStep {
  image: string;
  title: string;
}

@Component({
  selector: 'app-helix-lite-info',
  standalone: true,
  templateUrl: './helix-lite-info.component.html',
  styleUrls: ['./helix-lite-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, NzCollapseModule, CarouselModule],
})
export class HelixLiteInfoComponent {
  @ViewChild('carousel')
  private carousel: CarouselComponent | undefined;
  wasHelixLiteInfoHidden = false;

  logoImg = helixLiteLogoSvg;

  steps: HelixLiteStep[] = [
    {
      image: step1,
      title: 'Выберите нужные анализы и&nbsp;оплатите их онлайн',
    },
    {
      image: step2,
      title: 'Письмо с подтверждением заказа придет на электронную почту',
    },
    {
      image: step3,
      title: 'Посетите любой удобный пункт Helix Lite',
    },
    {
      image: step4,
      title: 'Отсканируйте QR-код в процедурном кабинете и сдайте биоматериал',
    },
    {
      image: step5,
      title: 'Получите результаты на email',
    },
  ];

  carouselOptionsHLProcessInfo: OwlOptions = {
    loop: true,
    nav: true,
    navText: [''],
    mouseDrag: false,
    responsive: {
      0: {
        items: 1,
      },
    },
  };

  protected isCollapseOpen$ = new BehaviorSubject<boolean>(false);

  constructor(protected navigationMenu: NavigationMenuService) {}

  hideHelixLiteInfo(): void {
    this.wasHelixLiteInfoHidden = true;
  }

  nextCarouselSlide() {
    this.carousel?.next();
  }

  collapseChangeState($event: boolean) {
    this.isCollapseOpen$.next($event);
  }
}
